import script from "./EventsSelect.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./EventsSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventsSelect.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./EventsSelect.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__